import ViiluFullPageDialog from 'ui/components/ViiluFullPageDialog'
import { useIntl } from 'react-intl'
import usePayment from './usePayment'
import { paymentViewHeaders, paymentsTableHeaders } from './constants'
import {
	DataTable,
	TableBody,
	TableColumn,
	TableHeader,
	TableRow,
} from 'react-md'
import { TableContainer } from 'ui/StyledComponents/Tables'
import styled from 'styled-components'
import type { PaymentHeader } from './types'

const StyledDataTable = styled(DataTable)`
	max-height: calc(100vh - 400px);
	td {
		white-space: nowrap;
	}
`

const Table = styled.table`
	border-collapse: collapse;
	border: 1px solid rgba(0, 0, 0, 0.2);
	min-width: 30vw;

	td {
		padding: 4px 8px;
		white-space: nowrap;
		border-bottom: 1px solid rgba(0, 0, 0, 0.2);
	}

	td:nth-child(2) {
		text-align: right;
	}
`

const Content = styled.div`
	flex: 1;
	display: flex;
	overflow: auto;
`

const Left = styled.div`
	padding: 16px;
	border-right: 1px solid rgba(0, 0, 0, 0.2);
`

const Right = styled.div`
	padding: 16px;
	flex: 1;
`

type Props = {
	id?: string | null
	onHide: () => void
}

const PaymentView = ({ id, onHide }: Props) => {
	const intl = useIntl()

	const { payment } = usePayment(id)

	const getValue = (key: any) => {
		if (!payment) return '-'

		return payment[key] || '-'
	}

	const renderTableHeaders = (headers: PaymentHeader[]) => {
		return (
			<TableRow>
				{headers
					.filter((h) => h.show)
					.map((header) => (
						//@ts-ignore //TODO: REMOVE
						<TableColumn key={header.key}>
							<p className="text-strong text-subtle">{header.title(intl)}</p>
						</TableColumn>
					))}
			</TableRow>
		)
	}

	const renderPaymentsTable = () => {
		return (
			<TableContainer>
				<StyledDataTable plain>
					<TableHeader
						style={{
							position: 'sticky',
							top: 0,
							zIndex: 1,
						}}
					>
						{renderTableHeaders(paymentsTableHeaders)}
					</TableHeader>

					<TableBody>
						{/* TODO: Loop table rows according to some data */}
						<TableRow>
							{/* TODO: Use some actual data */}
							{paymentsTableHeaders.map((input) => (
								<TableColumn>{String(input.title(intl))}</TableColumn>
							))}
						</TableRow>
					</TableBody>
				</StyledDataTable>
			</TableContainer>
		)
	}

	const renderPayment = () => {
		return (
			<Table>
				<tbody>
					{paymentViewHeaders.map((header) => {
						const { key, title } = header
						return (
							<tr key={String(key)}>
								<td>{title(intl)}</td>
								<td>{getValue(key) || '-'}</td>
							</tr>
						)
					})}
				</tbody>
			</Table>
		)
	}

	const renderChildren = () => {
		return (
			<Content>
				<Left>{renderPayment()}</Left>
				<Right>{renderPaymentsTable()}</Right>
			</Content>
		)
	}

	const actions = [
		{
			id: 'dialog-cancel',
			children: intl.formatMessage({
				defaultMessage: 'Sulje',
				description: 'Cancel button',
			}),
			onClick: onHide,
		},
	]

	return (
		<ViiluFullPageDialog
			id="payment-view-dialog"
			visible
			title={intl.formatMessage({
				defaultMessage: 'Suoritus',
				description: 'Payment',
			})}
			toolbarStyle={{
				background: 'var(--color-primary-dark)',
				boxShadow: 'none',
			}}
			actions={actions}
			onHide={onHide}
		>
			{renderChildren()}
		</ViiluFullPageDialog>
	)
}

export default PaymentView
